module.exports = __webpack_public_path__ + "725a53bed9e61d0ecba1e04cd937e7c5.fbx";